<template>
  <div data-testid="email-opt-outs">
    <!-- FT-188 REQ-07 / CTR-05: необязательные письма компании — переключатель вида для всей компании и адреса,
         отключившие виды по ссылке «Не присылать такие письма». Отключения клиентов видны без права вернуть. -->
    <h3 class="mb-1">{{ $t("email_opt_outs.title") }}</h3>
    <p class="caption grey--text mb-2">{{ $t("email_opt_outs.description") }}</p>
    <v-progress-linear v-if="loading" indeterminate height="2" class="mb-2"></v-progress-linear>

    <v-switch
      v-for="row in kinds"
      :key="row.kind"
      :input-value="!row.company_disabled"
      :label="$t(`email_opt_outs.kinds.${row.kind}`)"
      :disabled="busy"
      :data-testid="`email-kind-${row.kind}`"
      class="mt-0"
      dense
      hide-details
      @change="toggleKind(row, $event)"
    ></v-switch>

    <h4 class="mt-4 mb-1">{{ $t("email_opt_outs.addresses_title") }}</h4>
    <p v-if="loaded && addresses.length === 0" class="caption grey--text" data-testid="email-opt-outs-empty">
      {{ $t("email_opt_outs.empty") }}
    </p>
    <v-simple-table v-else dense>
      <tbody>
        <tr v-for="item in addresses" :key="item.id" :data-testid="`email-opt-out-${item.id}`">
          <td>{{ item.email }}</td>
          <td>{{ $t(`email_opt_outs.kinds.${item.kind}`) }}</td>
          <td class="grey--text">{{ $t(`email_opt_outs.owner.${item.owner}`) }}</td>
          <td class="text-right">
            <span v-if="item.owner === 'client'" class="caption grey--text">{{ $t("email_opt_outs.client_hint") }}</span>
            <v-btn v-else small text color="primary" :loading="pending === item.id" :disabled="busy"
              :data-testid="`email-restore-${item.id}`" @click="restore(item)">
              {{ $t("email_opt_outs.restore") }}
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "EmailOptOutsSettings",
  data() {
    return {
      kinds: [],
      addresses: [],
      loading: false,
      // Подсказка «никто не отключал» — только после успешной загрузки, не при ошибке.
      loaded: false,
      // Ключ запроса в работе: вид (строка) или id адреса (число); null — свободно.
      pending: null,
    };
  },
  computed: {
    // Один запрос за раз: v-switch переключает себя сам, и проигнорированный клик оставил бы его в чужом состоянии.
    busy() {
      return this.pending !== null;
    },
    authHeaders() {
      return { headers: { Authorization: this.$store.getters.getAuthToken } };
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      return this.axios
        .get("/api/v1/email_opt_outs", this.authHeaders)
        .then((response) => {
          this.kinds = response.data.kinds || [];
          this.addresses = response.data.addresses || [];
          this.loaded = true;
        })
        .catch((error) => this.setError(error, this.$t("email_opt_outs.load_error")))
        .finally(() => (this.loading = false));
    },
    // Переключатель включён = письма приходят. Ошибка — откат к состоянию сервера.
    async toggleKind(row, enabled) {
      if (this.busy) return;
      const snapshot = { ...row };
      this.pending = row.kind;
      row.company_disabled = !enabled;
      try {
        if (!enabled) {
          const response = await this.axios.post("/api/v1/email_opt_outs", { kind: row.kind }, this.authHeaders);
          row.id = response.data.id;
        } else if (snapshot.id) {
          await this.axios.delete(`/api/v1/email_opt_outs/${snapshot.id}`, this.authHeaders);
          row.id = null;
        }
      } catch (error) {
        Object.assign(row, snapshot);
        this.setError(error, this.$t("email_opt_outs.save_error"));
      } finally {
        this.pending = null;
      }
    },
    async restore(item) {
      if (this.busy) return;
      this.pending = item.id;
      try {
        await this.axios.delete(`/api/v1/email_opt_outs/${item.id}`, this.authHeaders);
        this.addresses = this.addresses.filter((row) => row.id !== item.id);
        this.$notify(this.$t("email_opt_outs.restored"), "", "success", 3000);
      } catch (error) {
        this.setError(error, this.$t("email_opt_outs.save_error"));
      } finally {
        this.pending = null;
      }
    },
  },
};
</script>
